import { CSSProperties, ReactNode } from 'react';

const banner: CSSProperties = {
  display: 'flex',
  gap: 10,
  padding: '11px 14px',
  borderRadius: 8,
  background: 'var(--bui-bg-info, var(--bui-bg-neutral-2))',
  border: '1px solid var(--bui-border-info, var(--bui-border-1))',
};

const hint: CSSProperties = {
  fontSize: 12,
  color: 'var(--bui-fg-secondary)',
};

export const GuardrailsBanner = ({
  title,
  children,
}: {
  title?: string;
  children: ReactNode;
}) => (
  <div style={banner}>
    <svg
      aria-hidden
      width="15"
      height="15"
      viewBox="0 0 16 16"
      style={{
        flex: 'none',
        marginTop: 1,
        fill: 'none',
        stroke: 'var(--bui-fg-info, var(--bui-fg-secondary))',
        strokeWidth: 1.5,
      }}
    >
      <circle cx="8" cy="8" r="6.6" />
      <path d="M8 7.3v4" strokeLinecap="round" />
      <circle cx="8" cy="4.8" r="0.9" fill="currentColor" stroke="none" />
    </svg>
    <div>
      {title && <div style={{ fontSize: 13, fontWeight: 600 }}>{title}</div>}
      <div style={hint}>{children}</div>
    </div>
  </div>
);
